// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* iOS Grouped Table View style for Web Profile Settings */

.user_profile {
  min-height: 100vh;
  padding-bottom: 80px;
  padding-top: 0;
}

/* Compact profile toolbar: keep the card close under the corner controls. */
.user_profile > .header.user-profile-header {
  padding: 0.35rem 1.25rem 0;
  margin: 0.25rem 0 0;
  align-items: center;
}

.user_profile .user-info {
  padding-top: 0.35rem;
}

.user-profile-header__trailing {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.user-profile-header__trailing .lang-shortcut--inline {
  position: relative;
  left: auto;
  right: auto;
  top: auto;
  bottom: auto;
  z-index: 6;
  align-items: flex-end;
  pointer-events: auto;
}

/* Bottom-nav offset targets every .lang-shortcut; keep the profile control in the header row. */
html.app-bottom-nav-shell .user-profile-header__trailing .lang-shortcut--inline {
  top: auto;
  bottom: auto;
}

.user-profile-header .header-role-btn,
.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn {
  width: 44px;
  height: 44px;
  max-width: 44px;
  max-height: 44px;
}

.user-profile-header .header-role-btn,
.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn,
.user-profile-help-btn,
.user-profile-logout-btn {
  background: var(--brand-surface, #fff);
  border-color: color-mix(in srgb, var(--text-color, #111827) 12%, transparent);
  box-shadow: 0 4px 10px var(--shadow-color);
}

.dark-mode .user-profile-header .header-role-btn,
.dark-mode .user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn,
.dark-mode .user-profile-help-btn {
  background: var(--surface-color);
  border-color: var(--border-color);
}

.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn {
  color: var(--text-color);
}

.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn.is-open {
  background: var(--brand-primary, #0877bc);
  border-color: var(--brand-primary, #0877bc);
  color: #fff;
}

.dark-mode .user-profile-header .header-role-btn--admin,
.dark-mode .user-profile-header .header-role-btn--committee,
.dark-mode .user-profile-header .header-role-btn--moderator {
  color: #93c5fd;
}

.dark-mode .user-profile-header .header-role-btn--coach,
.dark-mode .user-profile-header .header-role-btn--monitor {
  color: #5eead4;
}

.dark-mode .user-profile-header .header-role-btn--parent {
  color: #fbbf24;
}

.dark-mode .user-profile-header .header-role-btn--player {
  color: var(--brand-primary-light, #7dd3fc);
}


.user-profile-header .header-role-btn--player {
  padding: 2px;
}

.user-profile-header .header-role-btn--player .player-role-icon {
  width: 100% !important;
  height: 100% !important;
}

.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__panel {
  left: 0;
  right: auto;
  z-index: 20;
  min-width: 200px;
  max-width: min(280px, calc(100vw - 16px));
}

.user-profile-help-btn {
  height: 44px;
  padding: 0 12px;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);
  background: var(--brand-surface, #fff);
  color: var(--brand-primary, #0877bc);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 650;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 4px 10px var(--shadow-color);
}

.dark-mode .user-profile-help-btn {
  color: var(--brand-primary-light, #7dd3fc);
  background: var(--surface-color);
  border-color: color-mix(in srgb, var(--brand-primary-light, #7dd3fc) 42%, var(--border-color));
}

.user-profile-help-btn:hover {
  transform: translateY(-2px);
}

.user-profile-help-btn:focus-visible {
  outline: 2px solid var(--brand-primary, #0877bc);
  outline-offset: 2px;
}

.user-profile-logout-btn {
  height: 44px;
  padding: 0 12px;
  box-sizing: border-box;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, #ff453a 32%, transparent);
  background: color-mix(in srgb, #ff453a 8%, var(--brand-surface, #fff));
  color: #d92d20;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 650;
  box-shadow: 0 4px 10px var(--shadow-color);
  cursor: pointer;
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-tap-highlight-color: transparent;
}

.user-profile-logout-btn svg {
  width: 16px;
  height: 16px;
}

.dark-mode .user-profile-logout-btn {
  color: #ffb4ab;
  border-color: color-mix(in srgb, #ffb4ab 45%, var(--border-color));
  background: color-mix(in srgb, #ff453a 16%, var(--surface-color));
}

.user-profile-logout-btn:hover {
  transform: translateY(-2px);
  border-color: rgba(255, 69, 58, 0.4);
  box-shadow: 0 6px 16px rgba(255, 69, 58, 0.14), 0 2px 4px rgba(0, 0, 0, 0.04);
}

.user-profile-logout-btn:active {
  transform: translateY(0) scale(0.96);
}

.user-profile-logout-btn:disabled {
  opacity: 0.55;
  cursor: wait;
}

.user-profile-logout-btn:focus-visible {
  outline: 2px solid #ff453a;
  outline-offset: 2px;
}

.user-profile-logout-dialog.MuiPaper-root,
.user-profile-logout-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  margin: 16px !important;
  background: var(--surface-color, #111827) !important;
  color: var(--text-color, #f9fafb) !important;
  box-shadow: 0 24px 60px var(--shadow-color, rgba(0, 0, 0, 0.35)) !important;
}

.user-profile-logout-dialog--light {
  background: #ffffff !important;
  color: #111827 !important;
  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.16) !important;
}

.user-profile-logout-confirm {
  padding: 1.4rem 1.35rem 1.2rem;
  text-align: center;
}

.user-profile-logout-confirm__icon {
  width: 52px;
  height: 52px;
  margin: 0 auto 0.85rem;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ff453a;
  background: color-mix(in srgb, #ff453a 12%, transparent);
  border: 1px solid color-mix(in srgb, #ff453a 22%, transparent);
  font-size: 20px;
}

.dark-mode .user-profile-logout-confirm__icon {
  color: #ffb4ab;
}

.user-profile-logout-confirm h2 {
  margin: 0 0 0.45rem;
  font-size: 1.15rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.user-profile-logout-confirm p {
  margin: 0 0 1.2rem;
  font-size: 0.92rem;
  line-height: 1.45;
  color: var(--text-secondary, #64748b);
}

.user-profile-logout-dialog--light .user-profile-logout-confirm p {
  color: #4b5563;
}

.user-profile-logout-confirm__actions {
  display: flex;
  gap: 0.65rem;
}

.user-profile-logout-confirm__cancel,
.user-profile-logout-confirm__confirm {
  flex: 1 1;
  min-height: 44px;
  border-radius: 12px;
  font: inherit;
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  border: none;
  -webkit-tap-highlight-color: transparent;
}

.user-profile-logout-confirm__cancel {
  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent);
  color: var(--text-color, #111827);
}

.user-profile-logout-confirm__confirm {
  background: #ff453a;
  color: #fff;
}

.user-profile-logout-confirm__cancel:disabled,
.user-profile-logout-confirm__confirm:disabled {
  opacity: 0.6;
  cursor: wait;
}

@media (max-width: 400px) {
  .user-profile-header .header-role-btn,
  .user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn {
    width: 40px;
    height: 40px;
    max-width: 40px;
    max-height: 40px;
  }

  .user-profile-help-btn,
  .user-profile-logout-btn {
    height: 40px;
    padding: 0 8px;
    gap: 4px;
    font-size: 12px;
  }
}

.user-actions {
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  gap: 20px;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* iOS Grouped Section Card Container */
.user-action-buttons {
  border-radius: 18px;
  background: var(--glass-bg);
  border: 1px solid var(--glass-border);
  box-shadow: 0 8px 24px var(--shadow-color);
  backdrop-filter: blur(20px);
  display: flex;
  flex-direction: column;
  width: 100% !important;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
}

/* Individual Settings Rows */
.user-action-button-link {
  border: none;
  background: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;
  transition: background-color 0.2s cubic-bezier(0.16, 1, 0.3, 1), transform 0.15s cubic-bezier(0.16, 1, 0.3, 1);
  text-decoration: none;
}

.user-action-button-link:hover {
  background-color: var(--profile-hover-bg, rgba(255, 255, 255, 0.05));
}

.user-action-button-link:active {
  background-color: var(--profile-hover-bg, rgba(255, 255, 255, 0.09));
  transform: scale(0.985);
}

/* Row Left Side layout */
.user-action-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

/* SF Symbol style circle badge wrappers */
.ios-setting-icon-badge {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 16px;
  flex-shrink: 0;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

.ios-setting-icon-badge.profile  { background-color: var(--brand-primary, #0A84FF); } /* Brand primary */
.ios-setting-icon-badge.password { background-color: #FF9F0A; } /* Orange */
.ios-setting-icon-badge.language { background-color: #32D74B; } /* Green */
.ios-setting-icon-badge.level    { background-color: #BF5AF2; } /* Purple */
.ios-setting-icon-badge.logout   { background-color: #FF453A; } /* Red */

.user-action-button-link p {
  color: var(--text-color);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.2;
  margin: 0;
  letter-spacing: -0.1px;
}

/* Chevron arrow on right side */
.user-action-chevron {
  color: var(--text-secondary);
  opacity: 0.45;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease, color 0.2s ease;
  width: 20px;
  height: 20px;
}

.user-action-button-link:hover .user-action-chevron {
  opacity: 0.75;
  transform: translateX(1px);
}

/* Row fine borders */
.user-action-buttons > hr {
  border: none;
  height: 1px;
  background-color: var(--border-color);
  margin: 0 0 0 54px; /* Align border offset with text label, leaving icons clear */
  padding: 0;
}

/* Standalone Destructive Logout Cell overrides */
.user-action-button-link.destructive p {
  color: #FF453A;
  font-weight: 600;
}

.user-action-button-link.destructive:hover {
  background-color: rgba(255, 69, 58, 0.08);
}

.user-action-button-link.destructive:active {
  background-color: rgba(255, 69, 58, 0.12);
}

/* Theme Toggle Row Segmented Control */
.theme-toggle-row {
  cursor: default !important;
}

.theme-toggle-row:hover {
  background-color: transparent !important;
}

.ios-setting-icon-badge.theme {
  background-color: #5856D6; /* Purple Theme */
}

.theme-toggle-options {
  display: flex;
  background-color: var(--profile-segmented-bg, rgba(120, 120, 128, 0.15));
  border-radius: 8px;
  padding: 2px;
  gap: 2px;
}

.theme-toggle-btn {
  border: none;
  background: transparent;
  color: var(--text-color);
  opacity: 0.6;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.theme-toggle-btn.active {
  background-color: var(--brand-primary);
  color: #ffffff;
  opacity: 1;
  box-shadow: 0 1px 3px var(--shadow-color);
}

.light-mode .theme-toggle-btn {
  color: var(--text-color, #1e1e1e);
}

.light-mode .theme-toggle-btn.active {
  background-color: var(--brand-primary, #0877bc);
  color: #ffffff;
}

.dark-mode .theme-toggle-btn {
  color: var(--text-color, #f9fafb);
}

.dark-mode .theme-toggle-btn.active {
  background-color: var(--brand-primary, #0877bc);
  color: #ffffff;
}

/* Responsive Overrides */
@media (max-width: 540px) {
  .user-actions {
    padding: 1rem;
    gap: 16px;
  }
  .user-action-buttons {
    border-radius: 14px;
  }
  .user-action-button-link {
    padding: 12px 14px;
  }
  .user-action-button-link p {
    font-size: 14px;
  }
  .user-action-buttons > hr {
    margin-left: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UserAction.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D;EACE,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,4EAA4E;AAC5E;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,gGAAgG;AAChG;EACE,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,sCAAsC;EACtC,6EAA6E;EAC7E,0CAA0C;AAC5C;;AAEA;;;EAGE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yCAAyC;EACzC,2CAA2C;EAC3C,WAAW;AACb;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,OAAO;EACP,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,oFAAoF;EACpF,sCAAsC;EACtC,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,8FAA8F;AAChG;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,8DAA8D;EAC9D,sEAAsE;EACtE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,cAAc;EACd,iDAAiD;EACjD,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kEAAkE;EAClE,iEAAiE;AACnE;;AAEA;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,6EAA6E;AAC/E;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,oDAAoD;EACpD,4CAA4C;EAC5C,2EAA2E;AAC7E;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,yDAAyD;AAC3D;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,wDAAwD;EACxD,8DAA8D;EAC9D,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,8EAA8E;EAC9E,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;;IAEE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,cAAc;IACd,QAAQ;IACR,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;EAC1C,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,oFAAoF;AACtF;;AAEA,6BAA6B;AAC7B;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,8GAA8G;EAC9G,qBAAqB;AACvB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,oEAAoE;EACpE,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,0CAA0C;AAC1C;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,cAAc;EACd,yCAAyC;AAC3C;;AAEA,mCAAmC,+CAA+C,EAAE,EAAE,kBAAkB;AACxG,mCAAmC,yBAAyB,EAAE,EAAE,WAAW;AAC3E,mCAAmC,yBAAyB,EAAE,EAAE,UAAU;AAC1E,mCAAmC,yBAAyB,EAAE,EAAE,WAAW;AAC3E,mCAAmC,yBAAyB,EAAE,EAAE,QAAQ;;AAExE;EACE,wBAAwB;EACxB,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC;EACE,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,kBAAkB,EAAE,6DAA6D;EACjF,UAAU;AACZ;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,uCAAuC;AACvC;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;AAC9C;;AAEA;EACE,aAAa;EACb,wEAAwE;EACxE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;EAC/C,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;IACb,SAAS;EACX;EACA;IACE,mBAAmB;EACrB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* iOS Grouped Table View style for Web Profile Settings */\n\n.user_profile {\n  min-height: 100vh;\n  padding-bottom: 80px;\n  padding-top: 0;\n}\n\n/* Compact profile toolbar: keep the card close under the corner controls. */\n.user_profile > .header.user-profile-header {\n  padding: 0.35rem 1.25rem 0;\n  margin: 0.25rem 0 0;\n  align-items: center;\n}\n\n.user_profile .user-info {\n  padding-top: 0.35rem;\n}\n\n.user-profile-header__trailing {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.user-profile-header__trailing .lang-shortcut--inline {\n  position: relative;\n  left: auto;\n  right: auto;\n  top: auto;\n  bottom: auto;\n  z-index: 6;\n  align-items: flex-end;\n  pointer-events: auto;\n}\n\n/* Bottom-nav offset targets every .lang-shortcut; keep the profile control in the header row. */\nhtml.app-bottom-nav-shell .user-profile-header__trailing .lang-shortcut--inline {\n  top: auto;\n  bottom: auto;\n}\n\n.user-profile-header .header-role-btn,\n.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn {\n  width: 44px;\n  height: 44px;\n  max-width: 44px;\n  max-height: 44px;\n}\n\n.user-profile-header .header-role-btn,\n.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn,\n.user-profile-help-btn,\n.user-profile-logout-btn {\n  background: var(--brand-surface, #fff);\n  border-color: color-mix(in srgb, var(--text-color, #111827) 12%, transparent);\n  box-shadow: 0 4px 10px var(--shadow-color);\n}\n\n.dark-mode .user-profile-header .header-role-btn,\n.dark-mode .user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn,\n.dark-mode .user-profile-help-btn {\n  background: var(--surface-color);\n  border-color: var(--border-color);\n}\n\n.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn {\n  color: var(--text-color);\n}\n\n.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn.is-open {\n  background: var(--brand-primary, #0877bc);\n  border-color: var(--brand-primary, #0877bc);\n  color: #fff;\n}\n\n.dark-mode .user-profile-header .header-role-btn--admin,\n.dark-mode .user-profile-header .header-role-btn--committee,\n.dark-mode .user-profile-header .header-role-btn--moderator {\n  color: #93c5fd;\n}\n\n.dark-mode .user-profile-header .header-role-btn--coach,\n.dark-mode .user-profile-header .header-role-btn--monitor {\n  color: #5eead4;\n}\n\n.dark-mode .user-profile-header .header-role-btn--parent {\n  color: #fbbf24;\n}\n\n.dark-mode .user-profile-header .header-role-btn--player {\n  color: var(--brand-primary-light, #7dd3fc);\n}\n\n\n.user-profile-header .header-role-btn--player {\n  padding: 2px;\n}\n\n.user-profile-header .header-role-btn--player .player-role-icon {\n  width: 100% !important;\n  height: 100% !important;\n}\n\n.user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__panel {\n  left: 0;\n  right: auto;\n  z-index: 20;\n  min-width: 200px;\n  max-width: min(280px, calc(100vw - 16px));\n}\n\n.user-profile-help-btn {\n  height: 44px;\n  padding: 0 12px;\n  box-sizing: border-box;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 28%, transparent);\n  background: var(--brand-surface, #fff);\n  color: var(--brand-primary, #0877bc);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 650;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-shadow: 0 4px 10px var(--shadow-color);\n}\n\n.dark-mode .user-profile-help-btn {\n  color: var(--brand-primary-light, #7dd3fc);\n  background: var(--surface-color);\n  border-color: color-mix(in srgb, var(--brand-primary-light, #7dd3fc) 42%, var(--border-color));\n}\n\n.user-profile-help-btn:hover {\n  transform: translateY(-2px);\n}\n\n.user-profile-help-btn:focus-visible {\n  outline: 2px solid var(--brand-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.user-profile-logout-btn {\n  height: 44px;\n  padding: 0 12px;\n  box-sizing: border-box;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, #ff453a 32%, transparent);\n  background: color-mix(in srgb, #ff453a 8%, var(--brand-surface, #fff));\n  color: #d92d20;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 650;\n  box-shadow: 0 4px 10px var(--shadow-color);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  -webkit-tap-highlight-color: transparent;\n}\n\n.user-profile-logout-btn svg {\n  width: 16px;\n  height: 16px;\n}\n\n.dark-mode .user-profile-logout-btn {\n  color: #ffb4ab;\n  border-color: color-mix(in srgb, #ffb4ab 45%, var(--border-color));\n  background: color-mix(in srgb, #ff453a 16%, var(--surface-color));\n}\n\n.user-profile-logout-btn:hover {\n  transform: translateY(-2px);\n  border-color: rgba(255, 69, 58, 0.4);\n  box-shadow: 0 6px 16px rgba(255, 69, 58, 0.14), 0 2px 4px rgba(0, 0, 0, 0.04);\n}\n\n.user-profile-logout-btn:active {\n  transform: translateY(0) scale(0.96);\n}\n\n.user-profile-logout-btn:disabled {\n  opacity: 0.55;\n  cursor: wait;\n}\n\n.user-profile-logout-btn:focus-visible {\n  outline: 2px solid #ff453a;\n  outline-offset: 2px;\n}\n\n.user-profile-logout-dialog.MuiPaper-root,\n.user-profile-logout-dialog {\n  border-radius: 20px !important;\n  overflow: hidden;\n  margin: 16px !important;\n  background: var(--surface-color, #111827) !important;\n  color: var(--text-color, #f9fafb) !important;\n  box-shadow: 0 24px 60px var(--shadow-color, rgba(0, 0, 0, 0.35)) !important;\n}\n\n.user-profile-logout-dialog--light {\n  background: #ffffff !important;\n  color: #111827 !important;\n  box-shadow: 0 24px 50px rgba(15, 23, 42, 0.16) !important;\n}\n\n.user-profile-logout-confirm {\n  padding: 1.4rem 1.35rem 1.2rem;\n  text-align: center;\n}\n\n.user-profile-logout-confirm__icon {\n  width: 52px;\n  height: 52px;\n  margin: 0 auto 0.85rem;\n  border-radius: 14px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #ff453a;\n  background: color-mix(in srgb, #ff453a 12%, transparent);\n  border: 1px solid color-mix(in srgb, #ff453a 22%, transparent);\n  font-size: 20px;\n}\n\n.dark-mode .user-profile-logout-confirm__icon {\n  color: #ffb4ab;\n}\n\n.user-profile-logout-confirm h2 {\n  margin: 0 0 0.45rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n}\n\n.user-profile-logout-confirm p {\n  margin: 0 0 1.2rem;\n  font-size: 0.92rem;\n  line-height: 1.45;\n  color: var(--text-secondary, #64748b);\n}\n\n.user-profile-logout-dialog--light .user-profile-logout-confirm p {\n  color: #4b5563;\n}\n\n.user-profile-logout-confirm__actions {\n  display: flex;\n  gap: 0.65rem;\n}\n\n.user-profile-logout-confirm__cancel,\n.user-profile-logout-confirm__confirm {\n  flex: 1;\n  min-height: 44px;\n  border-radius: 12px;\n  font: inherit;\n  font-size: 0.95rem;\n  font-weight: 700;\n  cursor: pointer;\n  border: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.user-profile-logout-confirm__cancel {\n  background: color-mix(in srgb, var(--brand-primary, #0877bc) 10%, transparent);\n  color: var(--text-color, #111827);\n}\n\n.user-profile-logout-confirm__confirm {\n  background: #ff453a;\n  color: #fff;\n}\n\n.user-profile-logout-confirm__cancel:disabled,\n.user-profile-logout-confirm__confirm:disabled {\n  opacity: 0.6;\n  cursor: wait;\n}\n\n@media (max-width: 400px) {\n  .user-profile-header .header-role-btn,\n  .user-profile-header__trailing .lang-shortcut--inline .lang-shortcut__btn {\n    width: 40px;\n    height: 40px;\n    max-width: 40px;\n    max-height: 40px;\n  }\n\n  .user-profile-help-btn,\n  .user-profile-logout-btn {\n    height: 40px;\n    padding: 0 8px;\n    gap: 4px;\n    font-size: 12px;\n  }\n}\n\n.user-actions {\n  display: flex;\n  flex-direction: column;\n  padding: 1.5rem;\n  gap: 20px;\n  width: 100%;\n  max-width: 720px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n/* iOS Grouped Section Card Container */\n.user-action-buttons {\n  border-radius: 18px;\n  background: var(--glass-bg);\n  border: 1px solid var(--glass-border);\n  box-shadow: 0 8px 24px var(--shadow-color);\n  backdrop-filter: blur(20px);\n  display: flex;\n  flex-direction: column;\n  width: 100% !important;\n  margin: 0 auto;\n  overflow: hidden;\n  box-sizing: border-box;\n  transition: background-color 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n/* Individual Settings Rows */\n.user-action-button-link {\n  border: none;\n  background: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 14px 18px;\n  cursor: pointer;\n  width: 100%;\n  box-sizing: border-box;\n  transition: background-color 0.2s cubic-bezier(0.16, 1, 0.3, 1), transform 0.15s cubic-bezier(0.16, 1, 0.3, 1);\n  text-decoration: none;\n}\n\n.user-action-button-link:hover {\n  background-color: var(--profile-hover-bg, rgba(255, 255, 255, 0.05));\n}\n\n.user-action-button-link:active {\n  background-color: var(--profile-hover-bg, rgba(255, 255, 255, 0.09));\n  transform: scale(0.985);\n}\n\n/* Row Left Side layout */\n.user-action-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n/* SF Symbol style circle badge wrappers */\n.ios-setting-icon-badge {\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  font-size: 16px;\n  flex-shrink: 0;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n}\n\n.ios-setting-icon-badge.profile  { background-color: var(--brand-primary, #0A84FF); } /* Brand primary */\n.ios-setting-icon-badge.password { background-color: #FF9F0A; } /* Orange */\n.ios-setting-icon-badge.language { background-color: #32D74B; } /* Green */\n.ios-setting-icon-badge.level    { background-color: #BF5AF2; } /* Purple */\n.ios-setting-icon-badge.logout   { background-color: #FF453A; } /* Red */\n\n.user-action-button-link p {\n  color: var(--text-color);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 1.2;\n  margin: 0;\n  letter-spacing: -0.1px;\n}\n\n/* Chevron arrow on right side */\n.user-action-chevron {\n  color: var(--text-secondary);\n  opacity: 0.45;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.2s ease, color 0.2s ease;\n  width: 20px;\n  height: 20px;\n}\n\n.user-action-button-link:hover .user-action-chevron {\n  opacity: 0.75;\n  transform: translateX(1px);\n}\n\n/* Row fine borders */\n.user-action-buttons > hr {\n  border: none;\n  height: 1px;\n  background-color: var(--border-color);\n  margin: 0 0 0 54px; /* Align border offset with text label, leaving icons clear */\n  padding: 0;\n}\n\n/* Standalone Destructive Logout Cell overrides */\n.user-action-button-link.destructive p {\n  color: #FF453A;\n  font-weight: 600;\n}\n\n.user-action-button-link.destructive:hover {\n  background-color: rgba(255, 69, 58, 0.08);\n}\n\n.user-action-button-link.destructive:active {\n  background-color: rgba(255, 69, 58, 0.12);\n}\n\n/* Theme Toggle Row Segmented Control */\n.theme-toggle-row {\n  cursor: default !important;\n}\n\n.theme-toggle-row:hover {\n  background-color: transparent !important;\n}\n\n.ios-setting-icon-badge.theme {\n  background-color: #5856D6; /* Purple Theme */\n}\n\n.theme-toggle-options {\n  display: flex;\n  background-color: var(--profile-segmented-bg, rgba(120, 120, 128, 0.15));\n  border-radius: 8px;\n  padding: 2px;\n  gap: 2px;\n}\n\n.theme-toggle-btn {\n  border: none;\n  background: transparent;\n  color: var(--text-color);\n  opacity: 0.6;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.theme-toggle-btn.active {\n  background-color: var(--brand-primary);\n  color: #ffffff;\n  opacity: 1;\n  box-shadow: 0 1px 3px var(--shadow-color);\n}\n\n.light-mode .theme-toggle-btn {\n  color: var(--text-color, #1e1e1e);\n}\n\n.light-mode .theme-toggle-btn.active {\n  background-color: var(--brand-primary, #0877bc);\n  color: #ffffff;\n}\n\n.dark-mode .theme-toggle-btn {\n  color: var(--text-color, #f9fafb);\n}\n\n.dark-mode .theme-toggle-btn.active {\n  background-color: var(--brand-primary, #0877bc);\n  color: #ffffff;\n}\n\n/* Responsive Overrides */\n@media (max-width: 540px) {\n  .user-actions {\n    padding: 1rem;\n    gap: 16px;\n  }\n  .user-action-buttons {\n    border-radius: 14px;\n  }\n  .user-action-button-link {\n    padding: 12px 14px;\n  }\n  .user-action-button-link p {\n    font-size: 14px;\n  }\n  .user-action-buttons > hr {\n    margin-left: 50px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
